import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ITableService } from '@sp-shared/components/table';
import { MetaHttpAdapter } from '@sp-core/http-adapters/meta-http-adapter';
import { HttpReferralsService } from '../../http-services/http-referrals/http-referrals.service';
import { ReferralsHttpAdapter } from '../../http-adapters/referrals-http-adapter';

@Injectable({
  providedIn: 'root',
})
export class ReferralsNotesService implements ITableService<IReferralNote> {
  constructor(private httpReferralsService: HttpReferralsService, private referralsHttpAdapter: ReferralsHttpAdapter) {}

  public getTableData(params: HttpParamsOptions, apiParams?: ApiParams): Observable<ITableData<IReferralNote>> {
    const referralId = apiParams?.referralId;
    if (!referralId) {
      throw new Error('Referral ID is required for getting referral notes');
    }

    return this.getReferralNotes(referralId, params);
  }

  public getReferralNotes(referralId: string, params: HttpParamsOptions): Observable<ITableData<IReferralNote>> {
    return this.httpReferralsService.getReferralsNotes(referralId, params).pipe(
      map((data) => ({
        data: data.data.map((item) => this.referralsHttpAdapter.transformToReferralNote(item)),
        meta: MetaHttpAdapter.transformToMeta(data.meta),
      })),
    );
  }

  public createNote(noteData: IReferralNoteCreateRequest): Observable<IReferralNote> {
    const apiRequest = this.referralsHttpAdapter.transformToReferralNoteCreateRequestApi(noteData);

    return this.httpReferralsService
      .createReferralNote(noteData.referralId, apiRequest)
      .pipe(map((response) => this.referralsHttpAdapter.transformToReferralNoteFromCreateResponse(response)));
  }
}
